import type { ApplicationKey } from '@atlassian/jira-common-constants/src/application-keys.tsx';
import { feedbackComponentsProps } from './constants.tsx';

export const canRenderFeedbackForApplication = (applicationKey: ApplicationKey): boolean =>
	Boolean(feedbackComponentsProps[applicationKey]);
